import { apiClient } from "../config";

async function editDataAccessPolicy(data: any, id: any) {
  const url = `/admin/programs/${id}/data-access-policy`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editDataAccessPolicy;
